import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaArrowLeft } from 'react-icons/fa';
import Layout from '../../../components/public/common/Layout';
import publicData from '../../../data/publicData.json';

const NotFoundPage = () => {
  const { company } = publicData;
  const { name } = company;

  return (
    <Layout>
      <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900 px-4">
        <div className="max-w-lg w-full text-center">
          <h1 className="text-9xl font-bold text-primary-600 dark:text-primary-400">404</h1>
          <h2 className="text-3xl font-semibold text-gray-800 dark:text-gray-200 mt-4">
            You've wandered into a digital 404 labyrinth.
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            No breadcrumbs, no Ariadne's thread, just endless corridors of broken links.
          </p>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            Fun, right? Just kidding – we've got you.
          </p>
          <p className="text-gray-600 dark:text-gray-400 mt-2 italic">
            Or just yell 'HELP' really loud. It probably won't work, but hey, worth a shot!
          </p>
          <div className="mt-8 flex justify-center space-x-4">
            <Link
              to="/"
              className="inline-flex items-center px-6 py-3 border border-gray-300 dark:border-gray-600 text-base font-medium rounded-md text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
            >
              <FaHome className="mr-2" />
              Go Home
            </Link>
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center px-6 py-3 border border-gray-300 dark:border-gray-600 text-base font-medium rounded-md text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
            >
              <FaArrowLeft className="mr-2" />
              Go Back
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFoundPage; 